// prefer default export if available
const preferDefault = m => m && m.default || m

exports.components = {
  "component---code-of-conduct-md": () => import("../../CODE_OF_CONDUCT.md" /* webpackChunkName: "component---code-of-conduct-md" */),
  "component---srcdocs-theming-mdx": () => import("../../srcdocs/theming.mdx" /* webpackChunkName: "component---srcdocs-theming-mdx" */),
  "component---srcdocs-upgrade-mdx": () => import("../../srcdocs/upgrade.mdx" /* webpackChunkName: "component---srcdocs-upgrade-mdx" */),
  "component---srcdocs-getstarted-mdx": () => import("../../srcdocs/getstarted.mdx" /* webpackChunkName: "component---srcdocs-getstarted-mdx" */),
  "component---srcdocs-components-toggle-toggle-mdx": () => import("../../srcdocs/components/Toggle/toggle.mdx" /* webpackChunkName: "component---srcdocs-components-toggle-toggle-mdx" */),
  "component---src-pages-404-js": () => import("../src/pages/404.js" /* webpackChunkName: "component---src-pages-404-js" */)
}

